import { Goicuoc5gService } from 'src/services/goicuoc5g.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const GOICUOC5G_NEW_CARE_SUCCESS = 'GOICUOC5G:NEW_CARE_SUCCESS'
export const GOICUOC5G_LIST_SUCCESS = 'GOICUOC5G:FIND_ALL_SUCCESS'
export const GOICUOC5G_LIST_FAILD = 'GOICUOC5G:FIND_ALL_FAILD'
export const GOICUOC5G_COUNT_ASSIGN_SUCCESS = 'GOICUOC5G:COUNT_ASSIGN_SUCCESS'
export const GOICUOC5G_COUNT_ASSIGN_FAILD = 'GOICUOC5G:COUNT_ASSIGN_FAILD'

export const GOICUOC5G_CREATE_SUCCESS = 'GOICUOC5G:CREATE_SUCCESS'
export const GOICUOC5G_CREATE_FAILD = 'GOICUOC5G:CREATE_FAILD'

export const GOICUOC5G_IMPORT_SUCCESS = 'GOICUOC5G:IMPORT_SUCCESS'
export const GOICUOC5G_SAVE_SUCCESS = 'GOICUOC5G:SAVE_SUCCESS'
export const GOICUOC5G_SAVE_FAILD = 'GOICUOC5G:SAVE_SUCCESS'

export const GOICUOC5G_DEL_SUCCESS = 'GOICUOC5G:DEL_SUCCESS'
export const GOICUOC5G_DEL_FAILD = 'GOICUOC5G:DEL_FAILD'

export const GOICUOC5G_ONE_SUCCESS = 'GOICUOC5G:FIND_ONE_SUCCESS'
export const GOICUOC5G_ONE_FAILD = 'GOICUOC5G:FIND_ONE_FAILD'

export const GOICUOC5G_HISTORY_LIST_SUCCESS = 'GOICUOC5G:HISTORY_FIND_ALL_SUCCESS'
export const GOICUOC5G_HISTORY_LIST_FAILD = 'GOICUOC5G:HISTORY_FIND_ALL_FAILD'

export const GOICUOC5G_UPDATE_FILTER = 'GOICUOC5G:UPDATE_FILTER'

export const GOICUOC5G_ORDER_SUCCESS = 'GOICUOC5G:ORDER_SUCCESS'
export const GOICUOC5G_ORDER_FAILD = 'GOICUOC5G:ORDER_FAILD'

export const GOICUOC5G_UPDATE_HOMEPAGE_FILTER = 'GOICUOC5G:GOICUOC5G_UPDATE_HOMEPAGE_FILTER'

export const GOICUOC5G_HOMEPAGE_LIST_SUCCESS = 'GOICUOC5G:FIND_HOMEPAGE_LIST_SUCCESS'
export const GOICUOC5G_HOMEPAGE_LIST_FAILD = 'GOICUOC5G:FIND_HOMEPAGE_LIST_FAILD'

export const GOICUOC5G_HOMEPAGE_ONE_SUCCESS = 'GOICUOC5G:FIND_HOMEPAGE_ONE_SUCCESS'
export const GOICUOC5G_HOMEPAGE_ONE_FAILD = 'GOICUOC5G:FIND_HOMEPAGE_ONE_FAILD'

export const GOICUOC5G_LIMIT_UPDATE_HOMEPAGE_FILTER = 'GOICUOC5G:GOICUOC5G_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const GOICUOC5G_LIMIT_HOMEPAGE_LIST_SUCCESS = 'GOICUOC5G:LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const GOICUOC5G_LIMIT_HOMEPAGE_LIST_FAILD = 'GOICUOC5G:LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const GOICUOC5G_LIMIT_HOMEPAGE_ONE_SUCCESS = 'GOICUOC5G:LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const GOICUOC5G_LIMIT_HOMEPAGE_ONE_FAILD = 'GOICUOC5G:LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const GOICUOC5G_HANDLE_IMPORT_ERRORS = 'GOICUOC5G:GOICUOC5G_HANDLE_IMPORT_ERRORS'

export const Goicuoc5gAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,

    homepageList,
    updateHomepageFilter,
    homepageFindOne,

    homepageLimitList,
    updateHomepageLimitFilter,
    homepageLimitFindOne,

    sendOrder,
}

function updateHomepageFilter(payload) {
    return { type: GOICUOC5G_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { goicuoc5g } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageGoicuoc5gFilter } = goicuoc5g;
        const homepageGoicuoc5gPage = homepageGoicuoc5gFilter.homepageGoicuoc5gPage;
        const homepageGoicuoc5gLimit = homepageGoicuoc5gFilter.homepageGoicuoc5gLimit;

        return new Promise((resolve, reject) => {
            Goicuoc5gService.homepageList(homepageGoicuoc5gFilter).then((rs) => {
                if (!!homepageGoicuoc5gFilter && homepageGoicuoc5gFilter.homepageGoicuoc5gPage === 0) {
                    dispatch(success({
                        homepageGoicuoc5gItems: rs.data.values,
                        homepageGoicuoc5gTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = goicuoc5g.homepageGoicuoc5gItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageGoicuoc5gLimit * homepageGoicuoc5gPage; i < homepageGoicuoc5gLimit * homepageGoicuoc5gPage + homepageGoicuoc5gLimit; i++) {
                        if (typeof rsDataValues[i - homepageGoicuoc5gLimit * homepageGoicuoc5gPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageGoicuoc5gLimit * homepageGoicuoc5gPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageGoicuoc5gItems: uniqueItems,
                        homepageGoicuoc5gTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: GOICUOC5G_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GOICUOC5G_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_HOMEPAGE_ONE_FAILD, error } }
}

function updateHomepageLimitFilter(payload) {
    return { type: GOICUOC5G_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageLimitList() {
    return (dispatch, getState) => {
        const { goicuoc5g } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageGoicuoc5gLimitFilter } = goicuoc5g;
        const homepageGoicuoc5gLimitPage = homepageGoicuoc5gLimitFilter.homepageGoicuoc5gLimitPage;
        const homepageGoicuoc5gLimitLimit = homepageGoicuoc5gLimitFilter.homepageGoicuoc5gLimitLimit;

        return new Promise((resolve, reject) => {
            Goicuoc5gService.homepageLimitList(homepageGoicuoc5gLimitFilter).then((rs) => {
                if (!!homepageGoicuoc5gLimitFilter && homepageGoicuoc5gLimitFilter.homepageGoicuoc5gLimitPage === 0) {
                    dispatch(success({
                        homepageGoicuoc5gLimitItems: rs.data.values,
                        homepageGoicuoc5gLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = goicuoc5g.homepageGoicuoc5gLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageGoicuoc5gLimitLimit * homepageGoicuoc5gLimitPage; i < homepageGoicuoc5gLimitLimit * homepageGoicuoc5gLimitPage + homepageGoicuoc5gLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageGoicuoc5gLimitLimit * homepageGoicuoc5gLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageGoicuoc5gLimitLimit * homepageGoicuoc5gLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageGoicuoc5gLimitItems: uniqueItems,
                        homepageGoicuoc5gLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: GOICUOC5G_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.homepageLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GOICUOC5G_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: GOICUOC5G_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            Goicuoc5gService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(Goicuoc5gAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: GOICUOC5G_CREATE_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            Goicuoc5gService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(Goicuoc5gAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: GOICUOC5G_CREATE_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GOICUOC5G_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { goicuoc5g } = getState()
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...goicuoc5g.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GOICUOC5G_LIST_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { goicuoc5g } = getState();
        const page = goicuoc5g && typeof goicuoc5g.filter !== 'undefined' && goicuoc5g.filter && typeof goicuoc5g.filter.page !== 'undefined' ? goicuoc5g.filter.page : 0;
        const limit = goicuoc5g && typeof goicuoc5g.filter !== 'undefined' && goicuoc5g.filter && typeof goicuoc5g.filter.limit !== 'undefined' ? goicuoc5g.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            Goicuoc5gService.findAll(page, limit, goicuoc5g.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count
                    }));
                    
                    resolve(rs);
                } else {
                    const oldItems = goicuoc5g.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count
                    }));

                    resolve(rs);
                }
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: GOICUOC5G_LIST_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: GOICUOC5G_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            Goicuoc5gService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(Goicuoc5gAction.list())
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(Goicuoc5gAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: GOICUOC5G_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: GOICUOC5G_SAVE_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            Goicuoc5gService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(Goicuoc5gAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
                alert("Không thể tạo, có thể do trùng tên gói cước trước đó!");
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: GOICUOC5G_CREATE_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(Goicuoc5gAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GOICUOC5G_CREATE_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(Goicuoc5gAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GOICUOC5G_DEL_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GOICUOC5G_ONE_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(Goicuoc5gAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { goicuoc5g } = getState()
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...goicuoc5g.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GOICUOC5G_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        Goicuoc5gService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt này do hiện tại đang tạm hết hàng. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GOICUOC5G_ORDER_SUCCESS, data } }
    function failure(error) { return { type: GOICUOC5G_ORDER_FAILD, error } }
}